import React, { useState, useEffect, useRef } from "react"
import cx from "classnames"

import CONSTANTS from "@/constants/index"
import styles from "@/components/core/SelectDropdown/index.module.scss"

const SelectDropdown = props => {
  const [showList, setShowList] = useState(false)
  const [opened, setOpened] = useState(false)
  const [customLabel, setCustomLabel] = useState(false)
  let isFocused = false
  const dropDownClass = cx({
    "select-dropdown": true,
    "dropdown--open": showList,
  })
  const dropdownRef = useRef(null)

  useEffect(() => {
    if (showList) {
      setOpened(true)
    } else if (!showList && opened && props.onClose) {
      props.onClose()
      setOpened(false)
    }
  }, [showList])

  const handleSelect = value => {
    props.onChange(value)
    setShowList(false)
  }

  const handleMouseDownEvent = () => {
    if (disabled) {
      return
    }
    isFocused = true
    setShowList(!showList)
    if (props.labelAfterClick) setCustomLabel(true)
  }

  const handleBlurEvent = e => {
    if (e instanceof MouseEvent) {
      isFocused
      setShowList(false)
    }
    if (typeof props.onBlur === "function") {
      props.onBlur()
    }
  }

  useEffect(() => {
    window.addEventListener("mousedown", onClickEvent)
    return () => {
      window.removeEventListener("mousedown", onClickEvent)
    }
  }, [showList])

  const onClickEvent = e => {
    const { current = {} } = dropdownRef
    if (showList && !current.contains(e.target)) {
      setShowList(false)
    }
  }

  useEffect(() => {
    if (props.labelAfterClick && !props.value) setCustomLabel(false)
  }, [props.value])

  const toggleList = () => {
    if (showList) {
      setShowList(false)
      document.getElementById(props.id).focus()
    } else {
      setShowList(true)
      document.getElementById(`${props.id}-list`)?.childNodes[0].focus()
    }
  }

  const btnKeyDown = e => {
    const { KEYCODE } = CONSTANTS
    switch (e.keyCode) {
      case KEYCODE.SPACE:
        break
      case KEYCODE.ENTER:
        e.preventDefault()
        toggleList()
        break
      default:
        break
    }
  }

  const handleKeyDown = (i, e) => {
    const { KEYCODE } = CONSTANTS
    const ele = document.getElementById(`${props.id}-list`).childNodes
    switch (e.keyCode) {
      case KEYCODE.ESC:
        toggleList()
        break
      case KEYCODE.UP:
        if (i > 0) ele[i - 1].focus()
        break
      case KEYCODE.DOWN:
        if (i < ele.length - 1) ele[i + 1].focus()
        break
      case KEYCODE.SPACE:
        break
      case KEYCODE.ENTER:
        ele[i].click()
        document.getElementById(props.id).focus()
        break
      default:
        break
    }
  }
  const {
    customClass,
    id,
    tabIndex,
    label,
    ariaLabel,
    ariaRequired,
    value,
    ariaStateText,
    data,
    showError,
    errorMessage,
    labelAfterClick,
    disabled,
  } = props

  return (
    <div className={styles.wrapper} ref={dropdownRef}>
      <div
        onClick={handleMouseDownEvent}
        onBlur={handleBlurEvent}
        className={`${dropDownClass} ${customClass ?? ""}`}
      >
        <div
          id={id}
          className={`select-dropdown__field ${
            (showError && !disabled) ? "--with-error" : ""
          } ${disabled? "--with-disable" : ""}`}
          onKeyDown={btnKeyDown}
          tabIndex={tabIndex ?? 0}
          role="combobox"
          aria-controls="dropdown-listbox"
          aria-expanded={showList}
          aria-haspopup="true"
          aria-label={
            label
              ? label.replace(/\*/g, "")
              : ariaLabel
              ? ariaLabel.replace(/\*/g, "")
              : ""
          }
          aria-required={ariaRequired ?? label.indexOf("*") > 0 ? true : false}
          aria-describedby={`${id}-selected`}
        >
          <div className="select-dropdown__display">
            <span
              aria-hidden
              className={`select-dropdown__placeholder ${
                value ? "--label" : ""
              }`}
            >
              {customLabel ? labelAfterClick : label}
            </span>
            {value && (
              <span id={`${id}-selected`} className="select-dropdown__value">
                {value}
              </span>
            )}
          </div>
          <div
            className={`select-dropdown__icon ${showList ? "--open" : ""}`}
            aria-hidden="true"
          >
            <img src="/icons/down-icon.svg" alt="open-icon" />
          </div>
        </div>
        {!disabled &&
        <ul
          id={`${id}-list`}
          className="select-dropdown__dropdown"
          role="listbox"
          tabIndex="-1"
          aria-expanded="true"
          data-testid={"select-dropdown"}
        >
          {!ariaStateText &&
            data?.map((item, i) => (
              <li
                key={i}
                className={`select-dropdown__list-item ${
                  item === value && "selected-item"
                }`}
                aria-selected={item === value}
                role="option"
                tabIndex="-1"
                onClick={() => handleSelect(item)}
                onKeyDown={e => handleKeyDown(i, e)}
              >
                <span className="select-dropdown__list-value">{item}</span>
              </li>
            ))}
          {ariaStateText &&
            data?.map((item, i) => (
              <li
                key={i}
                className={`select-dropdown__list-item ${
                  item.code === value && "selected-item"
                }`}
                aria-selected={item === value}
                role="option"
                tabIndex="-1"
                aria-label={item.name}
                onClick={() => handleSelect(item.code)}
                onKeyDown={e => handleKeyDown(i, e)}
              >
                <span className="select-dropdown__list-value">{item.code}</span>
              </li>
            ))}
        </ul>
        }
        {showError && errorMessage && !disabled && (
          <span
            aria-live="polite"
            role="region"
            className="select-dropdown__error-message"
          >
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  )
}

SelectDropdown.defaultProps = {
  label: "",
}

export default SelectDropdown
